import React from "react";
import { Col, Row } from "reactstrap";

const SummaryCards = ({ data }) => {
  return (
    <Row className="mx-0 my-3 d-flex justify-content-between align-items-center">
      <Col xs="auto" className="d-flex w-100 py-3 px-2">
        <div className="d-flex gap-3 row-gap-3 flex-wrap">
          {data.map((item, index) => (
            <div
              className="d-flex flex-row justify-between gap-2 px-4 py-4 align-items-start bg-white border border-light rounded-4"
              key={index}
              style={{ ...item.cardStyle }}
            >
              <div
                style={{ minWidth: "170px" ,color:"black"}}
                className="d-flex flex-column gap-3"
                
              >
                <span className="fs-6">{item.label}</span>
                <h5 className={`mb-0  ${item.countClass}`} >{item.value}</h5>
              </div>
              <i
                className={`fs-5 mb-4 ${item.iconClass}`}
                style={item.iconStyle}
              ></i>
            </div>
          ))}
        </div>
      </Col>
    </Row>
  );
};

export default SummaryCards;
